module.exports = __webpack_public_path__ + "img/bul_component_text.f672c340.svg";